export default class BaseModel {

};
